import React, { useEffect, useState, useMemo } from "react";  
import { useAxios } from "../../../common_nextgen/axios/AxiosHelper";  
import useCustomNavigate from "../../../common_nextgen/common_components/Navigation/NextGenNavigation";  
import getBackendUrl from "../../../environment/BackendService";  
import { fetchDropdownValues } from "../../../common_nextgen/common_components/dropdown/DropdownHelper";  
import { useLocation } from "react-router-dom";  
import { ROUTE_PATHS } from "../../../common_nextgen/utils/Constants";  
import { useToast } from "../../../common_nextgen/hooks/ToastContext";  
import { downloadCSV } from "../../../common_nextgen/utils/UtilFunctions";

  
const useStandardTroopSchedule = () => {  
  
  const {axios_helper_no_header} = useAxios();
  const location = useLocation();  
  const { MEDICARE_STANDARD_TROOP_SCHEDULE_STEPS } = ROUTE_PATHS; 
  const stateVal = location.state ?? [];
    const [currentState = {}] = [...stateVal].reverse();
    const previousState = [...stateVal];
    previousState.splice(stateVal.length - 1, 1);
    console.log("current state in form", currentState, previousState);


    const {
      selectedSchedules = [],
      previousScreen = "",
      currentIndex: initialIndex = 0,
      paramsData: initialParamsData = {
        sbsScheduleName: "",
        },
} = currentState;

  const [data, setData] = useState([]); /* Price Schedule Data */  
  const [paramsData, setParamsData] = useState(initialParamsData);
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [first, setFirst] = useState(0);  
  const [rows, setRows] = useState(10);  
  const [totalRecords, setTotalRecords] = useState(0);  
  const [rowData, setRowData] = useState("");  
  const [currentPage, setCurrentPage] = useState(0);  
  const [selectedRows, setSelectedRows] = useState([]);  
  const navigateToPage = useCustomNavigate();  
  const [dropdownValues, setDropdownValues] = useState({});  
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);  
  const [selectedOption, setSelectedOption] = useState("no");  
  const [currentYearFetch, setCurrentYearFetch] = useState(false);
  const [currentYear, setCurrentYear] = useState(0);
  const toast = useToast();   
  
  const screen_title = "Standard TrOOP Schedule";  
  const screenNumber = "RCSBS001";  
  
  /* Search form fields that needs to be shown for filtering */  
  const formFields = [  
    {  
      fieldLabel: "SBS Schedule Name",  
      name: "sbsScheduleName",  
      label: "Schedule",  
      type: "text",  
      fieldNature: "editable",  
      value: "",  
      maxLength: 10,  
    },  
  ];  
  
  /* Dropdown options fields that needs to be fetched with API */  
  const dropdownOptions = [];  
  
  const dropdownCondition = {  
    dropDowns: dropdownOptions.map((item) => item.field_label + item.condition),  
  };  
  
  /* ACTION BUTTONS info that needs to be displayed on the page */  
  const ctaButtons = [    
    {  
      button_label: "Export as CSV",  
      button_handeler: () => {  
        exportAsCSV();  
      },  
      button_key: "",  
    },  
  ];  

  const handleBack = () => {
    // if (currentIndex < selectedSchedules.length - 1) {
    //   setCurrentIndex(currentIndex + 1);
    // } else {
    //   navigateToPage(previousScreen, previousState);
    // }
  };

  /* Top Left Back button info that needs to be displayed on the page*/
  const leftButtons = [
    // { button_label: 'Back', button_handeler: handleBack, button_key: "F12" }
  ];
  
  /* Gear Icon Menu option CTAs */  
  const menuOptions = useMemo(()=>{return [  
    {  
      label: "Steps",  
      icon: <span className="material-icons">list</span>,  
      command: () => {  
        navigateToPage(MEDICARE_STANDARD_TROOP_SCHEDULE_STEPS, [{ paramsData }, {  
          selectedSchedules: selectedRows.length ? selectedRows : [rowData],  
          previousScreen: location.pathname,  
          currentIndex:0,
          currentYear: currentYear,
          recordYear : getFirstFourCharsAsInt(rowData[parmKey]),
        }]);  
      },  
    },  
  ]},[currentYear, rowData]);   
  
  /* Data table column info. */  
  const columnDef = [  
    {  
      header: "Schedule",  
      field: "sbsScheduleName",  
    },  
    {  
      header: "Description",  
      field: "sbsScheduleDesc",  
    },  
  ];  
  
  /* Param Key which used as bridge between various operations on tabluar data */  
  const parmKey = "sbsScheduleName";  
  
  /* Handler that fetches the data */  
  const fetchData = async () => {  
    const page = first / rows;  
    try {  
      const raw_response = await axios_helper_no_header(  
        "GET",  
        `api/sbsStdBrandDiscSched`,  
        null,  
        {  
          page: page,  
          size: rows,  
          ...paramsData,  
        }  
      );  
      const response = raw_response.responseData;  
      const pageResponse = raw_response.responsePaginationDTO;  
      if (response.length === 0) {  
        setData([]);  
        setTotalRecords(0);   
        toast.current.show({  
          severity: "info",  
          summary: "",  
          detail: response.responseStatus.message,  
          life: 3000,  
        });  
      } else {  
        setData(response);    
        setTotalRecords(pageResponse.totalRecords); // Assuming the API returns totalRecords  
      }  
    } catch (error) {  
      console.error("Error fetching data:", error);  
      setData([]);  
      setTotalRecords(0);  
    }  
  };  
  
  const fetchDropdownData = async (dataDropdown) => {  
    try {  
      const response = await fetchDropdownValues(dataDropdown);  
      setDropdownValues(response);  
    } catch (error) {  
      console.error("Error fetching dropdown values:", error);  
    }  
  };  
  
  useEffect(() => {  
    fetchDropdownData(dropdownCondition);  
  }, []);  
  
  useEffect(() => {  
      fetchData(); // Initial fetch with page 0 and page size 10  

  }, [paramsData, rows, currentPage, selectedOption]);  

 
  const fetchCurrentYear = async () => {
    try {
        const response = await axios_helper_no_header("GET", "api/accumsDate/currentYear");
        const currentYear = response.responseData;
        if(!paramsData.sbsScheduleName){
          setParamsData(prevParams => ({
            ...prevParams,
            sbsScheduleName: currentYear,
        }));
        }
        
        setCurrentYearFetch(true);
        setCurrentYear(currentYear)
    } catch (error) {
        console.error("Error fetching current year:", error);
    }
};

useEffect(() => {
    if (!currentYearFetch) {
        fetchCurrentYear();
    }
}, [paramsData, currentYearFetch]);
  
  const onPageChange = (event) => {  
    console.log("page change", event.first, event);  
    setFirst(event.first);  
    setCurrentPage(event.page);  
    setRows(event.rows);  
  };  
  
  const openConfirmationModal = () => {  
    setIsConfirmationModalOpen(true);  
  };  
  
  const closeConfirmationModal = () => {  
    console.log(selectedOption);  
    setIsConfirmationModalOpen(false);  
    setSelectedOption("no");  
  };  

  const exportAsCSV = async () => {
    const queryParams = { ...paramsData };
    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/sbsStdBrandDiscSched/exportCsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };
  
  const updateParamData = (data) => {  
    setFirst(0);  
    setCurrentPage(0);  
    setParamsData(data);  
  };  

  function getFirstFourCharsAsInt(inputString) {  
    if (inputString.length >= 4) {  
      const firstFourChars = inputString.substring(0, 4);  
      const intNumber = parseInt(firstFourChars, 10);  
      return intNumber;  
    } else {  
      throw new Error("Input string must be at least 4 characters long");  
    }  
  }
  
  return {  
    screenNumber,  
    screen_title,  
    formFields,  
    dropdownValues,  
    paramsData,  
    updateParamData,  
    ctaButtons,  
    leftButtons,
    data,  
    parmKey,  
    menuOptions,  
    columnDef,  
    setRowData,  
    selectedRows,  
    setSelectedRows,  
    first,  
    rows,  
    totalRecords,  
    currentPage,  
    onPageChange,  
    isConfirmationModalOpen,  
    closeConfirmationModal,  
    setSelectedOption,  
  };  
};  
  
export default useStandardTroopSchedule; 